import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36c1416e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents" }
const _hoisted_2 = { class: "action-buttons" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, " plus_one ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.placeholderItems, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: item,
      class: "container"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ion_item, {
          lines: "none",
          class: _normalizeClass(_ctx.itemClass)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_textarea, {
              "auto-grow": true,
              inputmode: "text",
              autocapitalize: "sentences",
              placeholder: "Type something",
              value: _ctx.items[index] || '',
              onIonInput: ($event: any) => (_ctx.insertItem($event.detail.value as string, index))
            }, null, 8, ["value", "onIonInput"])
          ]),
          _: 2
        }, 1032, ["class"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_ion_button, {
          "aria-label": "Add one more",
          color: "success",
          size: "small",
          shape: "round",
          fill: "clear",
          strong: true,
          onClick: _ctx.onAddMoreItem
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 2
        }, 1032, ["onClick"]), [
          [_vShow, _ctx.items.length > 0 && index === _ctx.placeholderItems.length - 1 && _ctx.items[index]?.length > 0]
        ]),
        _withDirectives(_createVNode(_component_ion_button, {
          "aria-label": "Remove",
          color: "warning",
          size: "small",
          shape: "round",
          fill: "clear",
          strong: true,
          onClick: ($event: any) => (_ctx.onRemoveLastItem(index))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faMinusCircle }, null, 8, ["icon"])
          ]),
          _: 2
        }, 1032, ["onClick"]), [
          [_vShow, _ctx.items.length > 0 && _ctx.items[index]?.length > 0]
        ])
      ])
    ]))
  }), 128))
}